import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-attribute-create',
    styleUrls: ['./dialog.css'],
    template: `
        <h1 mat-dialog-title>
            Sind Sie sicher, dass sie dieses Merkmal anlegen wollen?
        </h1>
        <div mat-dialog-content>
            <p>Name: {{ data.feature.name }}</p>
        </div>
        <div mat-dialog-actions>
            <button
                mat-button
                (click)="onClick(true)"
                class="btn_green"
                cdkFocusInitial
            >
                Speichern
            </button>
            <button
                mat-button
                (click)="onClick(false)"
                class="btn_green"
                cdkFocusInitial
            >
                Abbrechen
            </button>
        </div>
    `,
    standalone: false
})
export class DialogAttributeCreate {
    constructor(
        public dialogRef: MatDialogRef<DialogAttributeCreate>,
        @Inject(MAT_DIALOG_DATA) public data
    ) { }

    onClick(result: boolean): void {
        this.dialogRef.close(result);
    }
}
